var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.isDarkMode)?_c('div',[_c('v-app',{attrs:{"dark":""}},[_c('frame')],1)],1):_c('div',[_c('v-app',[_c('frame')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }